import * as React from "react";
const SvgFiRrSearchDollar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-search-dollar_svg__a)">
      <path
        fill="#062147"
        d="m23.707 22.293-5.968-5.968A9.96 9.96 0 0 0 20 10c0-5.514-4.486-10-10-10S0 4.486 0 10s4.486 10 10 10a9.95 9.95 0 0 0 6.325-2.261l5.968 5.968a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414M2 10c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8-8-3.589-8-8m12 2c0 1.654-1.346 3-3 3v1a1 1 0 1 1-2 0v-1h-.268a3.01 3.01 0 0 1-2.598-1.499 1 1 0 0 1 1.731-1.002c.179.31.511.501.867.501H11c.551 0 1-.448 1-1a.77.77 0 0 0-.644-.761l-3.041-.506A2.76 2.76 0 0 1 6 8c0-1.654 1.346-3 3-3V4a1 1 0 1 1 2 0v1h.268a3.01 3.01 0 0 1 2.598 1.499 1 1 0 1 1-1.731 1.002A1 1 0 0 0 11.268 7H9c-.551 0-1 .448-1 1a.77.77 0 0 0 .644.761l3.041.506A2.76 2.76 0 0 1 14 12"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-search-dollar_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSearchDollar;
